import { i18n } from '@lingui/core';

import { DEFAULT_LOCALE, SupportedLocale } from './locales';

export const dynamicActivate = async (locale: SupportedLocale) => {
  const { messages } = await import(`../locales/${locale}/messages.po`);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

i18n.load(DEFAULT_LOCALE, {});
i18n.activate(DEFAULT_LOCALE);

export { i18n };
